<div class="custom-slider d-flex align-items-baseline" *ngIf="sliderOptions">
  <div>
    <p class="custom-slider-label">{{ _value.timeslotStart }}h - {{ _value.timeslotEnd }}h</p>
  </div>
  <div class="flex-grow-1">
    <ngx-slider
      *ngIf="_loaded"
      [(value)]="_value.timeslotStart"
      [(highValue)]="_value.timeslotEnd"
      [options]="sliderOptions"
      [id]="id"
      [manualRefresh]="manualRefresh"
      (valueChange)="handleChange(_value)"
      (highValueChange)="handleChange(_value)"
    ></ngx-slider>
  </div>
</div>
